// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Shubham Dixit <shubham@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import { cn } from '@/lib/utils'

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('shimmer rounded-xl', className)} />
}

export function ChatSkeleton() {
  return (
    <div className="flex flex-col gap-6 px-5 py-4">
      {/* Assistant message skeleton */}
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-3">
          <Skeleton className="w-9 h-9 rounded-full flex-shrink-0" />
          <div className="flex flex-col gap-1.5">
            <Skeleton className="w-28 h-3" />
            <Skeleton className="w-16 h-2.5" />
          </div>
        </div>
        <Skeleton className="w-full h-4" />
        <Skeleton className="w-5/6 h-4" />
        <Skeleton className="w-4/6 h-4" />
      </div>
      {/* User message skeleton */}
      <div className="flex flex-col gap-3 border-b border-border pb-4">
        <div className="flex items-center gap-3">
          <Skeleton className="w-9 h-9 rounded-sm flex-shrink-0" />
          <div className="flex flex-col gap-1.5">
            <Skeleton className="w-16 h-3" />
            <Skeleton className="w-12 h-2.5" />
          </div>
        </div>
        <Skeleton className="w-32 h-4" />
      </div>
      {/* Another assistant message */}
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-3">
          <Skeleton className="w-9 h-9 rounded-full flex-shrink-0" />
          <div className="flex flex-col gap-1.5">
            <Skeleton className="w-28 h-3" />
            <Skeleton className="w-16 h-2.5" />
          </div>
        </div>
        <Skeleton className="w-48 h-5" />
        <Skeleton className="w-full h-4" />
        <Skeleton className="w-3/4 h-4" />
      </div>
    </div>
  )
}

export function ProfileSkeleton() {
  return (
    <div className="flex flex-col gap-5 p-5">
      {/* Header card */}
      <div className="rounded-2xl overflow-hidden">
        <Skeleton className="h-32 rounded-2xl" />
      </div>
      {/* Tabs */}
      <div className="flex gap-2">
        <Skeleton className="h-9 w-24 rounded-full" />
        <Skeleton className="h-9 w-24 rounded-full" />
        <Skeleton className="h-9 w-24 rounded-full" />
      </div>
      {/* Cards */}
      <Skeleton className="h-24 w-full" />
      <Skeleton className="h-20 w-full" />
      <Skeleton className="h-20 w-full" />
    </div>
  )
}
